import React from 'react';
import {SmallTitle} from 'ui';
import InformationTile from './informationTile';
// import bg1 from 'assets/img/tileBg1.png';
import bg2 from 'assets/img/tileBg2.png';
import {Container} from './styles';

const tileData = [
  {
    imageUrl: bg2,
    bigTitle: 'Nos produits',
    smallTitle: 'Offres restauration & glacier',
    id: 2,
    link: '/products',
  },
];

const RecipeInformation = () => (
  <Container>
    <SmallTitle style={{marginTop: 21, marginBottom: 23}}>À découvrir sur le site</SmallTitle>
    {tileData.map(data => (
      <InformationTile key={data.id} {...data} />
    ))}
  </Container>
);

export default RecipeInformation;
